import axios from 'axios'

function setDefaultAuthHeader(token: string) {
  axios.defaults.headers.common['Authorization'] = token
}

export default setDefaultAuthHeader
